import React, { useState, useEffect } from "react";

import ContractHoldersList from "./ContractHoldersList.jsx";
import ContractHoldersHeader from "./Header.jsx";

import { getContractHoldersList, getContractHoldersGroups } from "../../../api/contractHolders.js";
import { removedBannedChs } from "../../../util/bannedChs.js";

import { SEARCH_TYPE_NAME } from "../../../constants.js";

export default function ContractHoldersGroups({ setFetchError }) {
  /** @type {[ContractHolder[], React.Dispatch<React.SetActionState<ContractHolder[]>>]} */
  const [contractHolderList, setContractHolderList] = useState([]);
  /** @type {[ContractHolderGroup[], React.Dispatch<React.SetActionState<ContractHolderGroup[]>>]} */
  const [contractHoldersGroups, setContractHoldersGroups] = useState([]);
  const [options, setOptions] = useState({
    groupOptions: {},
    otherOptions: [],
  });
  const [searchType, setSearchType] = useState(SEARCH_TYPE_NAME);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    getContractHoldersList()
      .then((contractHolderListData) => {
        setContractHolderList(removedBannedChs(contractHolderListData));
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  useEffect(() => {
    getContractHoldersGroups()
      .then((contractHoldersGroups) => {
        setContractHoldersGroups(contractHoldersGroups);
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  if (!contractHolderList.length) {
    return <div>Loading Contract Holders Data...</div>;
  } else {
    return (
      <div className="contract-holders">
        <ContractHoldersHeader
          contractHoldersGroups={contractHoldersGroups}
          options={options}
          setOptions={setOptions}
          searchType={searchType}
          setSearchType={setSearchType}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
        <ContractHoldersList
          options={options}
          searchType={searchType}
          searchValue={searchValue}
          contractHolderListData={contractHolderList}
        />
      </div>
    );
  }
}
